import { Skeleton } from "~/components/ui/skeleton";
import { useFetcher } from "~/hooks/useFetcher";
import { ResourceLoadError } from "~/pages/manifold-nextgen/components/ResourceLoadError";
import { AgentConnectorsTab } from "~/pages/manifold-nextgen/components/agents/AgentConnectorsTab";
import { AgentProfileTab } from "~/pages/manifold-nextgen/components/agents/AgentProfileTab";
import { AgentSkillsTab } from "~/pages/manifold-nextgen/components/agents/AgentSkillsTab";
import { AgentToolkitsTab } from "~/pages/manifold-nextgen/components/agents/AgentToolkitsTab";
import { Agent, agentPath } from "~/services/agents";
import { SessionContextDetailHeader, SessionContextViewOption } from "./SessionContextDetailHeader";

const AGENT_VIEWS: SessionContextViewOption[] = [
  { value: "overview", label: "Overview" },
  { value: "skills", label: "Skills" },
  { value: "connectors", label: "Connectors" },
  { value: "toolkits", label: "Toolkits" },
];

interface SessionContextAgentDetailProps {
  agentId: string;
  view: string;
  onBack: () => void;
  onSetView: (view: string) => void;
}

export const SessionContextAgentDetail = ({
  agentId,
  view,
  onBack,
  onSetView,
}: SessionContextAgentDetailProps) => {
  const { data: agent, error, isLoading } = useFetcher<Agent>(agentPath(agentId));

  return (
    <div className="flex h-full flex-col overflow-hidden">
      <SessionContextDetailHeader
        entityName={agent?.display_name ?? "…"}
        onBack={onBack}
        views={AGENT_VIEWS}
        currentView={view}
        onSetView={onSetView}
      />

      <div className="flex-1 overflow-y-auto p-4">
        {isLoading ? (
          <div className="flex flex-col gap-3" role="status" aria-label="Loading agent">
            <Skeleton className="h-8 w-2/3 rounded-md" />
            <Skeleton className="h-32 rounded-lg" />
          </div>
        ) : error || !agent ? (
          <ResourceLoadError error={error} resourceLabel="agent" className="py-16" />
        ) : (
          <>
            {view === "overview" && <AgentProfileTab agent={agent} sessionSidebarView />}
            {view === "skills" && <AgentSkillsTab agent={agent} sessionSidebarView />}
            {view === "connectors" && <AgentConnectorsTab agent={agent} sessionSidebarView />}
            {view === "toolkits" && <AgentToolkitsTab agent={agent} sessionSidebarView />}
          </>
        )}
      </div>
    </div>
  );
};
